module.exports = __webpack_public_path__ + "img/featured-bio-space.8c435d35.jpg";